<template>
  <div class="page">
    <div class="page-title">編輯職員</div>
    <div class="form-box">
    <staffFrom :form="form"></staffFrom>
    <div class="page-button">
        <el-button type="info" @click="onSubmit">提交</el-button>
        <el-button type="success" @click="onBackUser">取消</el-button>
    </div>
    </div>
  </div>
</template>

<script>
import {getUserDetail,putUser} from '@/api/users'
import staffFrom from "./components/staffFrom.vue";
export default {
  components: { staffFrom },
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      form: {
        userNo: null,
        name: null,
        gender: 0,
        email: null,
        password: null,
        confirmPassword: null,
        areaCode: null,
        phone: null,
        roleId: 0,
        avatar: null,
        country: null,
        area: null,
        district: null,
        address: null,
        students: [
          {
            userNo: null,
            name: null,
            gender: 0,
            branchSchool: {
              name: {
                en: null,
                zhTc: null,
              },
              abbreviation: null,
            },
            password: null,
            confirmPassword: null,
            grade: {
              name: null,
              price: 0,
            },
            avatar: null,
            birthday: null,
            studentCode: null,
          },
        ],
      },
    };
  },
  created(){
    this.getUserDetail()
  },
  methods:{
    onSubmit(){
      this.putUser()
    },
    putUser(){
       putUser(this.id,this.form).then(()=>{
            this.$message.success('修改成功')
            this.onBackUser()
       })
    },
    onBackUser() {
      let path = ``
        path = `/staff`
        // this.resolveRouter(path)
        this.$router.push({path: path})
    },
    getUserDetail(){
      getUserDetail(this.id).then((v)=>{
        this.form =v.data
        this.form.confirmPassword = this.form.password
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.form-box {
  margin-top: 50px;
  overflow: hidden;
  background-color: #fff;
  padding: 20px;
}
</style>